import {
  ProgressBarCancelled,
  ProgressBarCompleted,
  ProgressBarInProgress,
  ProgressBarPending,
  ProgressBarUnknown,
  lightTheme,
} from '@vgrubs/components';
import { vDriveDeliveryStatus } from 'components/src/types/api/wallet.types';
import styled from 'styled-components';

export const RenderStatus = (status: vDriveDeliveryStatus) => {
  switch (status) {
    case vDriveDeliveryStatus.pending_assign:
    case vDriveDeliveryStatus.pending_merchant:
      return {
        progressBar: <ProgressBarPending />,
        color: lightTheme.yellow,
        name: 'Pending',
        progress: 0,
      };

    case vDriveDeliveryStatus.runner_assigned:
    case vDriveDeliveryStatus.en_route_pickup:
    case vDriveDeliveryStatus.arrived_pickup:
    case vDriveDeliveryStatus.picked_up:
    case vDriveDeliveryStatus.en_route_dropoff:
    case vDriveDeliveryStatus.arrived_dropoff:
      return {
        progressBar: <ProgressBarInProgress />,
        color: lightTheme.darkBlue,
        name: 'In Progress',
        progress: 33,
      };

    case vDriveDeliveryStatus.cancelled:
      return {
        progressBar: <ProgressBarCancelled />,
        color: lightTheme.primary,
        name: 'Cancelled',
        progress: 100,
      };

    case vDriveDeliveryStatus.completed:
      return {
        progressBar: <ProgressBarCompleted />,
        color: lightTheme.green,
        name: 'Completed',
        progress: 100,
      };

    case vDriveDeliveryStatus.returned:
      return {
        progressBar: <ProgressBarCancelled />,
        color: lightTheme.orange,
        name: 'Returned',
        progress: 100,
      };

    case vDriveDeliveryStatus.scheduled:
      return {
        progressBar: <ProgressBarUnknown />,
        color: lightTheme.lightGray,
        name: 'Scheduled',
        progress: 0,
      };

    case vDriveDeliveryStatus.unknown:
      return {
        progressBar: <ProgressBarUnknown />,
        color: lightTheme.lightGray,
        name: 'Unknown',
        progress: 0,
      };

    default:
      break;
  }
};

export const TimelineCircle = styled.div<{
  $color?: string | null;
}>`
  width: 10px;
  height: 10px;
  background-color: ${({ theme, $color }) => $color ?? theme.green};
  border-radius: 50%;
  position: absolute;
  left: -24px;
`;

export const TimelineLineTop = styled.div<{
  $color?: string | null;
}>`
  width: 2px;
  height: 36px;
  background-color: ${({ theme, $color }) => $color ?? theme.green};
  position: absolute;
  left: -20px;
  top: -1px;
`;

export const TimelineLineBottom = styled.div<{
  $color?: string | null;
}>`
  width: 2px;
  height: 36px;
  background-color: ${({ theme, $color }) => $color ?? theme.green};
  position: absolute;
  left: -20px;
  bottom: -1px;
`;
